import { render } from "./MagicToolGeneratedImageRenderer.vue?vue&type=template&id=127fcb26"
import script from "./MagicToolGeneratedImageRenderer.vue?vue&type=script&lang=js"
export * from "./MagicToolGeneratedImageRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/MagicToolGeneratedImageRenderer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "127fcb26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('127fcb26', __exports__)) {
    api.reload('127fcb26', __exports__)
  }
  
  module.hot.accept("./MagicToolGeneratedImageRenderer.vue?vue&type=template&id=127fcb26", () => {
    api.rerender('127fcb26', render)
  })

}


export default __exports__